import React from 'react';
import logo from '../../Css/logo.svg';

import './footer.css';

// Muestra el footer de la tienda (pie de pagina)

 const Footer = () => {
    return (
        <footer className="footer-area">
            <div className="footer-bg" ></div>    
            <div className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="footer-logo">
                                <div className="logo">
                                    <img src={logo} alt="marca" /> 
                                </div>
                                <div className="copy-right">
                                    <p>Copyright & Design By</p>
                                    <h4>F&N Shop - 2021</h4>
                                </div>  
                                <div className="footer-contact-info">
                                    <div className="single-box">
                                        <div className="icon">
                                            <span className="icon-phone-call"></span>
                                        </div>
                                        <div className="title">
                                            <span>Telefono</span>
                                            <h3><a href="tel:123456789">+54 9 1122334455</a></h3>
                                        </div>
                                    </div>
                                    <div className="single-box">
                                        <div className="icon">
                                            <span className="icon-phone-call"></span>
                                        </div>
                                        <div className="title">
                                            <span>Email</span>
                                            <h3><a href="mailto:logistic@email.com">info@f&NShop.com</a></h3>
                                        </div>
                                    </div>
                                    <div className="single-box">
                                        <div className="icon">
                                            <span className="icon-phone-call"></span>
                                        </div>
                                    </div>
                                    <div className="footer-social-info">
                                        <a href="/" className="fb-clr"><i className="fab fa-facebook-f"></i></a>
                                        <a href="/" className="tw-clr"><i className="fab fa-twitter"></i></a>
                                        <a href="/" className="you-clr"><i className="fab fa-youtube"></i></a>
                                        <a href="/" className="sk-clr"><i className="fab fa-skype"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div className="footer-menu">
                                <ul>
                                    <li><a href="/">Terms & Condiciones</a></li>
                                    <li><a href="/">Politica de Privacidad</a></li>
                                    <li><a href="/">Politica de Reembolso</a></li>
                                    <li><a href="/">Soporte</a></li>
                                </ul>
                            </div>
                            
                        </div>  
                        
                    </div>
                </div>
            </div>
        </footer>   
    )
}
export default Footer;